<template>
  <div>
    <h1 class="display-1 my-6 mx-4">Choose Customer</h1>
    <v-autocomplete
      v-model="customer"
      :loading="loading"
      :items="customers"
      :search-input.sync="search"
      cache-items
      class="ma-4"
      flat
      hide-no-data
      hide-details
      item-text="name"
      item-value="id"
      label="What account would you like to view?"
      solo-inverted
      @change="loadCustomer"
    ></v-autocomplete>
  </div>
</template>

<script>
import CustomerData from "../customerData";

export default {
  name: "Customers",
  data() {
    return {
      customer: "",
      loading: false,
      customers: [],
      search: null
    };
  },
  computed: {
    fakeCustomers() {
      return CustomerData;
    }
  },
  watch: {
    search(val) {
      val && val !== this.select && this.querySelections(val);
    }
  },
  methods: {
    querySelections(v) {
      this.loading = true;
      // Simulated ajax query
      setTimeout(() => {
        this.customers = this.fakeCustomers.filter(e => {
          return (
            (e.name || "").toLowerCase().indexOf((v || "").toLowerCase()) > -1
          );
        });
        this.loading = false;
      }, 500);
    },
    loadCustomer() {
      this.$router.push({
        name: "customer",
        params: { customerId: this.customer }
      });
    }
  }
};
</script>

<style scoped></style>
